import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class MultiProductSlider extends UcoastEl {
	static htmlSelector = 'multi-product-slider'
	collectionTriggers: NodeListOf<HTMLHeadingElement>
	constructor() {
		super()
		this.collectionTriggers = q.rl('.featured-collection__banner-title', this)
		this.collectionTriggers.forEach(trigger => {
			trigger.addEventListener('click', this.onClickCollectionTrigger.bind(this));
		})
	}

	onClickCollectionTrigger(e: Event) {
		e.preventDefault();
		const target = e.currentTarget as HTMLElement
		if(!target) return
		const collectionId = target.dataset.collectionId
		q.ol('.featured-collection__banner-buttons a, .featured-collection-wrapper, .featured-collection__banner-title, .featured-collection__banner-text')?.forEach(container => {
			container.classList.toggle('active', container.dataset.collectionId == collectionId)
		})
	}
}
